import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { capitalizeFirstLetter, formateDateWithMonthAdmin, showStatus } from "../../../../../utils/commonfunction";
import { useTranslation } from "react-i18next";
import { Placeholder } from "rsuite";
import Breadcrums from "../../../common/breadcrumbs";
import * as productPreSubManagement from "../../../services/productPreSubManagement";
import toHtml from "html-react-parser";

const ViewPreSubCategories = (props) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const params = useParams();
    const [showdefault, setShowDefault] = useState({});
    const breadcrumbs = [
        { title: t("sidebar_link_dashboard"), url: "/admin/dashboard" },
        {
            title: t("pre_sub_categories"),
            url: "/admin/productManagement/presubcategories/list/1",
        },
        { title: t("btn_view"), url: "" },
    ];

    useEffect(() => {
        productPreSubManagement
            .Details(params.id)
            .then((response) => {
                setShowDefault(response && response.data ? response.data : []);
            })
            .catch((error) => {
                console.log("error=====>", error);
            });
    }, [params.id]);

    return (
        <>
            <Breadcrums data={breadcrumbs} />
            <div className="row row-sm">
                <div className="col-lg-12 col-md-12 animation_fade">
                    <div className="card custom-card">
                        <div className="card-body">
                            <div>
                                <h6 className="main-content-label mb-3">
                                    {t('View Pre-Sub Category')}
                                </h6>
                            </div>
                            {showdefault && Object.keys(showdefault).length > 0 ? (
                                <div className="row">
                                    <div className="col-lg-12 form-group">
                                        <table
                                            id="simple-table"
                                            className="table  table-bordered table-hover"
                                        >
                                            <tbody>
                                                <tr>
                                                    <th>{t("parent_category")}</th>
                                                    <td className="text-capitalize">
                                                        {showdefault && showdefault.parentCategory
                                                            ? capitalizeFirstLetter(showdefault.parentCategory)
                                                            : "N/A"}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>{t("sub_category")}</th>
                                                    <td className="text-capitalize">
                                                        {showdefault && showdefault.subCategory
                                                            ? capitalizeFirstLetter(showdefault.subCategory)
                                                            : "N/A"}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>{t("label_name")}</th>
                                                    <td className="text-capitalize">
                                                        {showdefault && showdefault.title
                                                            ? capitalizeFirstLetter(showdefault.title)
                                                            : "N/A"}
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <th>{t("label_description")}</th>
                                                    <td>
                                                        {showdefault && showdefault.description
                                                            ? capitalizeFirstLetter(showdefault.description)
                                                            : "N/A"}
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <th>{t("list_heading_status")}</th>
                                                    <td>
                                                        {showdefault && toHtml(showStatus(showdefault.status))}
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <th>{t("label_image")}</th>
                                                    <td><img src={showdefault && showdefault.image ? showdefault.image : ""} alt={showdefault?.title} style={{ height: "100px" }} /></td>
                                                </tr>
                                                <tr>
                                                    <th>{t("list_heading_created_date")}</th>
                                                    <td>
                                                        {showdefault && showdefault.createdAt
                                                            ? formateDateWithMonthAdmin(showdefault.createdAt)
                                                            : "N/A"}
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="col-lg-12 form-group">
                                        <h6 className="main-content-label mb-3">
                                            {t('Attributes')}
                                        </h6>
                                        <table className="table table-bordered table-hover">
                                            <thead>
                                                <tr>
                                                    <th>#</th>
                                                    <th>{t("label_name")}</th>
                                                    <th>{t('Grouping')}</th>
                                                    <th>{t('Type')}</th>
                                                    <th>{t('Values')}</th>
                                                    <th>{t('Multi Select')}</th>
                                                    <th>{t('Visible In Filter')}</th>
                                                    <th>{t("list_heading_status")}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {showdefault.attributeList && showdefault.attributeList.length > 0 ? (
                                                    showdefault.attributeList.map((attr, index) => (
                                                        <tr key={attr._id}>
                                                            <td>{index + 1}</td>
                                                            <td className="text-capitalize">{attr.name ? capitalizeFirstLetter(attr.name) : "N/A"}</td>
                                                            <td className="text-capitalize">{attr.grouping ? capitalizeFirstLetter(attr.grouping) : "N/A"}</td>
                                                            <td className="text-capitalize">{attr.attributeType ? attr.attributeType.replace(/_/g, " ") : "N/A"}</td>
                                                            <td>
                                                                {attr.values && attr.values.length > 0 ? (
                                                                    <div className="d-flex flex-wrap gap-2">
                                                                        {attr.values.map((v, i) => (
                                                                            <span key={i} className="badge bg-light text-dark border">
                                                                                {typeof v === 'object' && v !== null ? v.name : v}
                                                                            </span>
                                                                        ))}
                                                                    </div>
                                                                ) : "N/A"}
                                                            </td>
                                                            <td>{attr.isMultiSelect ? "Yes" : "No"}</td>
                                                            <td>{attr.isVisibleInFilter ? "Yes" : "No"}</td>
                                                            <td>{toHtml(showStatus(attr.status))}</td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan={8} className="text-center">{t('No attributes assigned')}</td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            ) : (
                                <Placeholder.Paragraph className="w-100" rowHeight={30} rowSpacing={5} active={true} rows={7} />
                            )}
                        </div>
                        <div className="mt-5 back-button">
                            <button
                                className="btn ripple btn-dark"
                                type="button"
                                onClick={() =>
                                    navigate("/admin/productManagement/presubcategories/list/1")
                                }
                            >
                                <i className="ace-icon-solid ion-arrow-return-left bigger-110 mx-1"></i>
                                {t("btn_back")}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ViewPreSubCategories;
